//Example
export const USER_TYPES = {
  SUPER_ADMIN: "Super Admin",
  FACILITY_ADMIN: "Facility Admin",
  FACILITY_USER: "Facility User",
  // Display-only label for the user_facility_admin persona (Admin Portal
  // role-separation) -- not a distinct functional role here, see roles.js.
  USER_FACILITY_ADMIN: "User Facility Admin",
  // Display-only label for the ro_admin persona: Super Admin view with
  // canExport=false (docs/ro-admin-role-requirements.md).
  READ_ONLY_ADMIN: "Read-Only Admin",
};

// Shown wherever a download/export/print control is hidden or refused for
// a Read-Only Admin (UI gates and the web-e 403 DOWNLOAD_FORBIDDEN_RO_ADMIN).
export const DOWNLOADS_DISABLED_MSG = "Downloads are disabled for your role";

// worksite
export const COLUMNS = {
  PARENT_ACCOUNT: {
    field: "parent_name",
    header: "Parent Account",
    style: { width: "18%" },
    headerClassName: "parent-account-header",
    expander: true,
    sortable: false,
  },

  ACCOUNT_NAME: {
    field: "account_name",
    header: "Account Name",
    style: { width: "18%" },
    sortable: true,
  },
  ACCOUNT_NUMBER: {
    field: "account_number",
    header: "Account Number",
    sortable: true,
  },
  ACCOUNT_STATUS: {
    field: "account_status",
    header: "Status",
    sortable: true,
  },
  ADDRESS: {
    field: "address",
    header: "Location",
    sortable: false,
  },
  TYPE: {
    field: "type",
    header: "Type",
    sortable: true,
  },
};

//SpendMangemnt
export const invoiceData = [
  {
    id: 1,
    providerNames: "Willam Schaffer ",
    invoiceDates: "9/29/2023",
    facilityNames: "Maine Veter Hospital",
    clientName: "Ascension",
    invoiceNumber: "INV-9067",
    status: "Paid",
    paymentTerm: "NET30",
    amount: "",
    accountReceived: "0 Akash Lee",
    confirmNumber: "A-02128",
    invoiceDate: "10/9/2023",
    speciality: "Hematology-Oncology",
  },
  {
    id: 2,
    providerNames: "Ava Swayze",
    invoiceDates: "8/29/2023",
    facilityNames: "Unity Point Hospital",
    clientName: "Acute Care Surgery",
    invoiceNumber: "INV-6785",
    status: "Paid",
    paymentTerm: "Due Upon Recepit",
    amount: "",
    accountReceived: "0 Rodrigo Botero",
    confirmNumber: "A-02148",
    invoiceDate: "10/9/2023",
    speciality: "Urology",
  },
  {
    id: 3,
    providerNames: "Willam Schaffer ",
    invoiceDates: "9/29/2023",
    facilityNames: "Maine Veter Hospital",
    clientName: "Ascension",
    invoiceNumber: "INV-9067",
    status: "Paid",
    paymentTerm: "NET30",
    amount: "",
    accountReceived: "0 Akash Lee",
    confirmNumber: "A-02128",
    invoiceDate: "10/9/2023",
    speciality: "Hematology-Oncology",
  },
  {
    id: 4,
    providerNames: "Ava Swayze",
    invoiceDates: "8/29/2023",
    facilityNames: "Unity Point Hospital",
    clientName: "Acute Care Surgery",
    invoiceNumber: "INV-6785",
    status: "Paid",
    paymentTerm: "Due Upon Recepit",
    amount: "",
    accountReceived: "0 Rodrigo Botero",
    confirmNumber: "A-02148",
    invoiceDate: "10/9/2023",
    speciality: "Urology",
  },
  {
    id: 5,
    providerNames: "Willam Schaffer ",
    invoiceDates: "9/29/2023",
    facilityNames: "Maine Veter Hospital",
    clientName: "Ascension",
    invoiceNumber: "INV-9067",
    status: "Paid",
    paymentTerm: "NET30",
    amount: "",
    accountReceived: "0 Akash Lee",
    confirmNumber: "A-02128",
    invoiceDate: "10/9/2023",
    speciality: "Hematology-Oncology",
  },
  {
    id: 6,
    providerNames: "Ava Swayze",
    invoiceDates: "8/29/2023",
    facilityNames: "Unity Point Hospital",
    clientName: "Acute Care Surgery",
    invoiceNumber: "INV-6785",
    status: "Paid",
    paymentTerm: "Due Upon Recepit",
    amount: "",
    accountReceived: "0 Rodrigo Botero",
    confirmNumber: "A-02148",
    invoiceDate: "10/9/2023",
    speciality: "Urology",
  },

  {
    id: 1,
    providerNames: "Willam Schaffer ",
    invoiceDates: "9/29/2023",
    facilityNames: "Maine Veter Hospital",
    clientName: "Ascension",
    invoiceNumber: "INV-9067",
    status: "Paid",
    paymentTerm: "NET30",
    amount: "",
    accountReceived: "0 Akash Lee",
    confirmNumber: "A-02128",
    invoiceDate: "10/9/2023",
    speciality: "Hematology-Oncology",
  },
  {
    id: 2,
    providerNames: "Ava Swayze",
    invoiceDates: "8/29/2023",
    facilityNames: "Unity Point Hospital",
    clientName: "Acute Care Surgery",
    invoiceNumber: "INV-6785",
    status: "Paid",
    paymentTerm: "Due Upon Recepit",
    amount: "",
    accountReceived: "0 Rodrigo Botero",
    confirmNumber: "A-02148",
    invoiceDate: "10/9/2023",
    speciality: "Urology",
  },
  {
    id: 3,
    providerNames: "Willam Schaffer ",
    invoiceDates: "9/29/2023",
    facilityNames: "Maine Veter Hospital",
    clientName: "Ascension",
    invoiceNumber: "INV-9067",
    status: "Paid",
    paymentTerm: "NET30",
    amount: "",
    accountReceived: "0 Akash Lee",
    confirmNumber: "A-02128",
    invoiceDate: "10/9/2023",
    speciality: "Hematology-Oncology",
  },
  {
    id: 4,
    providerNames: "Ava Swayze",
    invoiceDates: "8/29/2023",
    facilityNames: "Unity Point Hospital",
    clientName: "Acute Care Surgery",
    invoiceNumber: "INV-6785",
    status: "Paid",
    paymentTerm: "Due Upon Recepit",
    amount: "",
    accountReceived: "0 Rodrigo Botero",
    confirmNumber: "A-02148",
    invoiceDate: "10/9/2023",
    speciality: "Urology",
  },
  {
    id: 5,
    providerNames: "Willam Schaffer ",
    invoiceDates: "9/29/2023",
    facilityNames: "Maine Veter Hospital",
    clientName: "Ascension",
    invoiceNumber: "INV-9067",
    status: "Paid",
    paymentTerm: "NET30",
    amount: "",
    accountReceived: "0 Akash Lee",
    confirmNumber: "A-02128",
    invoiceDate: "10/9/2023",
    speciality: "Hematology-Oncology",
  },
  {
    id: 6,
    providerNames: "Ava Swayze",
    invoiceDates: "8/29/2023",
    facilityNames: "Unity Point Hospital",
    clientName: "Acute Care Surgery",
    invoiceNumber: "INV-6785",
    status: "Paid",
    paymentTerm: "Due Upon Recepit",
    amount: "",
    accountReceived: "0 Rodrigo Botero",
    confirmNumber: "A-02148",
    invoiceDate: "10/9/2023",
    speciality: "Urology",
  },
  {
    id: 7,
    providerNames: "Willam Schaffer ",
    invoiceDates: "9/29/2023",
    facilityNames: "Maine Veter Hospital",
    clientName: "Ascension",
    invoiceNumber: "INV-9067",
    status: "Paid",
    paymentTerm: "NET30",
    amount: "",
    accountReceived: "0 Akash Lee",
    confirmNumber: "A-02128",
    invoiceDate: "10/9/2023",
    speciality: "Hematology-Oncology",
  },
  {
    id: 8,
    providerNames: "Ava Swayze",
    invoiceDates: "8/29/2023",
    facilityNames: "Unity Point Hospital",
    clientName: "Acute Care Surgery",
    invoiceNumber: "INV-6785",
    status: "Paid",
    paymentTerm: "Due Upon Recepit",
    amount: "",
    accountReceived: "0 Rodrigo Botero",
    confirmNumber: "A-02148",
    invoiceDate: "10/9/2023",
    speciality: "Urology",
  },
  {
    id: 9,
    providerNames: "Willam Schaffer ",
    invoiceDates: "9/29/2023",
    facilityNames: "Maine Veter Hospital",
    clientName: "Ascension",
    invoiceNumber: "INV-9067",
    status: "Paid",
    paymentTerm: "NET30",
    amount: "",
    accountReceived: "0 Akash Lee",
    confirmNumber: "A-02128",
    invoiceDate: "10/9/2023",
    speciality: "Hematology-Oncology",
  },
  {
    id: 10,
    providerNames: "Ava Swayze",
    invoiceDates: "8/29/2023",
    facilityNames: "Unity Point Hospital",
    clientName: "Acute Care Surgery",
    invoiceNumber: "INV-6785",
    status: "Paid",
    paymentTerm: "Due Upon Recepit",
    amount: "",
    accountReceived: "0 Rodrigo Botero",
    confirmNumber: "A-02148",
    invoiceDate: "10/9/2023",
    speciality: "Urology",
  },
  {
    id: 11,
    providerNames: "Willam Schaffer ",
    invoiceDates: "9/29/2023",
    facilityNames: "Maine Veter Hospital",
    clientName: "Ascension",
    invoiceNumber: "INV-9067",
    status: "Paid",
    paymentTerm: "NET30",
    amount: "",
    accountReceived: "0 Akash Lee",
    confirmNumber: "A-02128",
    invoiceDate: "10/9/2023",
    speciality: "Hematology-Oncology",
  },
  {
    id: 12,
    providerNames: "Ava Swayze",
    invoiceDates: "8/29/2023",
    facilityNames: "Unity Point Hospital",
    clientName: "Acute Care Surgery",
    invoiceNumber: "INV-6785",
    status: "Paid",
    paymentTerm: "Due Upon Recepit",
    amount: "",
    accountReceived: "0 Rodrigo Botero",
    confirmNumber: "A-02148",
    invoiceDate: "10/9/2023",
    speciality: "Urology",
  },
];

//Facility user
export const facilityUser = [
  {
    sr_No: "1",
    facility_User: "Recruter",
    contactPerson: "Ava Davis",
    location: "Orlando",
    specialities: "Cardilogy",
    status: "Active",
  },
  {
    sr_No: "2",
    facility_User: "Department",
    contactPerson: "olivia Williams",
    location: "Maimi",
    specialities: "Oncology",
    status: "Active",
  },
  {
    sr_No: "3",
    facility_User: "Accounting",
    contactPerson: "Ethan Davis",
    location: "Tampa",
    specialities: "Orthopetics",
    status: "Active",
  },
  {
    sr_No: "4",
    facility_User: "Leadership",
    contactPerson: "James",
    location: "Orlando",
    specialities: "Cardilogy",
    status: "On Hold",
  },
  {
    sr_No: "5",
    facility_User: "Guest",
    contactPerson: "James",
    location: "Orlando",
    specialities: "Cardilogy",
    status: "On Hold",
  },
];

export const workSites = [
  {
    name: "Health Medical Center",
    type: "General",
    location: "1234 Sunshine Boulevard, Miami, Florida",
    admin: "Ethan Johnson",
    contacts: {
      hospital: "(123) 456-7890",
      general: "(123) 456-7890",
      email: "Info@BrowardHealthNoth.com",
      fax: "(123) 456-7890",
    },
    subscribed: true,
  },
  {
    name: "Health Medical Center",
    type: "General",
    location: "1234 Sunshine Boulevard, Miami, Florida",
    admin: "Ethan Johnson",
    contacts: {
      hospital: "(123) 456-7890",
      general: "(123) 456-7890",
      email: "Info@BrowardHealthNoth.com",
      fax: "(123) 456-7890",
    },
    subscribed: true,
  },
  {
    name: "Health Medical Center",
    type: "General",
    location: "1234 Sunshine Boulevard, Miami, Florida",
    admin: "Ethan Johnson",
    contacts: {
      hospital: "(123) 456-7890",
      general: "(123) 456-7890",
      email: "Info@BrowardHealthNoth.com",
      fax: "(123) 456-7890",
    },
    subscribed: true,
  },
  {
    name: "Health Medical Center",
    type: "General",
    location: "1234 Sunshine Boulevard, Miami, Florida",
    admin: "Ethan Johnson",
    contacts: {
      hospital: "(123) 456-7890",
      general: "(123) 456-7890",
      email: "Info@BrowardHealthNoth.com",
      fax: "(123) 456-7890",
    },
    subscribed: true,
  },
  {
    name: "Health Medical Center",
    type: "General",
    location: "1234 Sunshine Boulevard, Miami, Florida",
    admin: "Ethan Johnson",
    contacts: {
      hospital: "(123) 456-7890",
      general: "(123) 456-7890",
      email: "Info@BrowardHealthNoth.com",
      fax: "(123) 456-7890",
    },
    subscribed: true,
  },
  {
    name: "Health Medical Center",
    type: "General",
    location: "1234 Sunshine Boulevard, Miami, Florida",
    admin: "Ethan Johnson",
    contacts: {
      hospital: "(123) 456-7890",
      general: "(123) 456-7890",
      email: "Info@BrowardHealthNoth.com",
      fax: "(123) 456-7890",
    },
    subscribed: true,
  },
  {
    name: "Health Medical Center",
    type: "General",
    location: "1234 Sunshine Boulevard, Miami, Florida",
    admin: "Ethan Johnson",
    contacts: {
      hospital: "(123) 456-7890",
      general: "(123) 456-7890",
      email: "Info@BrowardHealthNoth.com",
      fax: "(123) 456-7890",
    },
    subscribed: true,
  },
];

export const worksiteUsers = [
  {
    userName: "John Doe",
    userType: "Admin",
    phoneNumber: "123-456-7890",
    accountName: "City Hospital",
    title: "Hospital Administrator",
    email: "johndoe@cityhospital.com",
  },
  {
    userName: "Jane Smith",
    userType: "Doctor",
    phoneNumber: "987-654-3210",
    accountName: "Green Valley Clinic",
    title: "Chief Surgeon",
    email: "janesmith@greenvalleyclinic.com",
  },
  {
    userName: "Michael Brown",
    userType: "Nurse",
    phoneNumber: "456-789-1234",
    accountName: "Blue River Hospital",
    title: "Senior Nurse",
    email: "michaelbrown@blueriverhospital.com",
  },
  {
    userName: "Emily Davis",
    userType: "Receptionist",
    phoneNumber: "321-654-9870",
    accountName: "Silver Oak Medical Center",
    title: "Front Desk Manager",
    email: "emilydavis@silveroak.com",
  },
  {
    userName: "Chris Wilson",
    userType: "Technician",
    phoneNumber: "789-123-4567",
    accountName: "Skyline Diagnostics",
    title: "Lab Technician",
    email: "chriswilson@skylinediagnostics.com",
  },
  {
    userName: "Patricia Taylor",
    userType: "Admin",
    phoneNumber: "654-987-3210",
    accountName: "Harmony Care",
    title: "HR Manager",
    email: "patriciataylor@harmonycare.com",
  },
  {
    userName: "James Anderson",
    userType: "Doctor",
    phoneNumber: "123-987-6543",
    accountName: "Sunrise Hospital",
    title: "Pediatrician",
    email: "jamesanderson@sunrisehospital.com",
  },
  {
    userName: "Laura Thomas",
    userType: "Nurse",
    phoneNumber: "456-123-7890",
    accountName: "Golden Valley Health",
    title: "Head Nurse",
    email: "laurathomas@goldenvalleyhealth.com",
  },
  {
    userName: "Daniel Martinez",
    userType: "Technician",
    phoneNumber: "789-456-1230",
    accountName: "Metro Labs",
    title: "X-ray Technician",
    email: "danielmartinez@metrolabs.com",
  },
  {
    userName: "Sophia Hernandez",
    userType: "Receptionist",
    phoneNumber: "321-789-6543",
    accountName: "Downtown Clinic",
    title: "Receptionist",
    email: "sophiahernandez@downtownclinic.com",
  },
  {
    userName: "Olivia White",
    userType: "Admin",
    phoneNumber: "654-321-9876",
    accountName: "River Valley Hospital",
    title: "Operations Manager",
    email: "oliviawhite@rivervalleyhospital.com",
  },
  {
    userName: "Ethan Harris",
    userType: "Doctor",
    phoneNumber: "987-321-6540",
    accountName: "Hilltop Medical",
    title: "Orthopedic Specialist",
    email: "ethanharris@hilltopmedical.com",
  },
  {
    userName: "Isabella Clark",
    userType: "Nurse",
    phoneNumber: "789-654-1239",
    accountName: "Oceanview Health",
    title: "Nurse Practitioner",
    email: "isabellaclark@oceanviewhealth.com",
  },
  {
    userName: "Alexander Lee",
    userType: "Technician",
    phoneNumber: "321-987-6547",
    accountName: "Mountain Labs",
    title: "Lab Assistant",
    email: "alexanderlee@mountainlabs.com",
  },
  {
    userName: "Mia Lewis",
    userType: "Receptionist",
    phoneNumber: "456-789-3211",
    accountName: "Lakeside Clinic",
    title: "Front Desk Staff",
    email: "mialewis@lakesideclinic.com",
  },
  {
    userName: "William Robinson",
    userType: "Admin",
    phoneNumber: "987-654-1238",
    accountName: "Evergreen Medical",
    title: "IT Administrator",
    email: "williamrobinson@evergreenmedical.com",
  },
  {
    userName: "Charlotte Walker",
    userType: "Doctor",
    phoneNumber: "654-123-7892",
    accountName: "Central Health",
    title: "Dermatologist",
    email: "charlottewalker@centralhealth.com",
  },
  {
    userName: "Benjamin Hall",
    userType: "Nurse",
    phoneNumber: "123-789-6543",
    accountName: "Northern Care",
    title: "Registered Nurse",
    email: "benjaminhall@northerncare.com",
  },
  {
    userName: "Abigail Young",
    userType: "Technician",
    phoneNumber: "789-123-4568",
    accountName: "Westside Labs",
    title: "Medical Imaging Specialist",
    email: "abigailyoung@westsidelabs.com",
  },
  {
    userName: "Lucas King",
    userType: "Receptionist",
    phoneNumber: "321-654-9871",
    accountName: "Eastside Clinic",
    title: "Clinic Coordinator",
    email: "lucasking@eastsideclinic.com",
  },
];

export const shiftdata = [
  {
    confirmationnumber: "A-05727",
    bookingstatus: "Active",
    firstname: "Kanayo",
    lastname: "Ubesie",
    clientname: "SSM Health Care Corporation",
    facilityname: "SSM Health St. Clare Hospital - Baraboo",
    practitionertype: "Physician",
    specialty: "OB/GYN",
    shiftstartdate: "12/14/2024",
    shiftenddate: "12/15/2024",
    shifttimes: "5:00 PM to 9:00 PM",
    shifttype: "Shift (Hourly)",
    facilitycity: "Baraboo",
    facilitystate: "WI",
    consultantname: "Killian Thrush",
  },
  {
    confirmationnumber: "A-05731",
    bookingstatus: "Active",
    firstname: "William",
    lastname: "Mackin",
    clientname: "Cheyenne Regional Medical Center",
    facilityname: "SSM Health St. Clare Hospital - Baraboo",
    practitionertype: "Physician",
    specialty: "OB/GYN",
    shiftstartdate: "12/13/2024",
    shiftenddate: "12/15/2024",
    shifttimes: "5:00 PM to 9:00 PM",
    shifttype: "Shift (Hourly)",
    facilitycity: "Baraboo",
    facilitystate: "WI",
    consultantname: "Killian Thrush",
  },
  {
    confirmationnumber: "A-05731",
    bookingstatus: "Active",
    firstname: "William",
    lastname: "Mackin",
    clientname: "Cheyenne Regional Medical Center",
    facilityname: "SSM Health St. Clare Hospital - Baraboo",
    practitionertype: "Physician",
    specialty: "OB/GYN",
    shiftstartdate: "12/14/2024",
    shiftenddate: "12/15/2024",
    shifttimes: "5:00 PM to 9:00 PM",
    shifttype: "Shift (Hourly)",
    facilitycity: "Baraboo",
    facilitystate: "WI",
    consultantname: "Killian Thrush",
  },
];

export const doccumentdata = [
  {
    filetype: "Excel",
    filename: "File Name",
    filesize: "124KB",
    uploadeddate: "04/12/2024",
    relatedto: "Related Name",
  },
  {
    filetype: "Word",
    filename: "File Name",
    filesize: "1.2MB",
    uploadeddate: "03/12/2024",
    relatedto: "Related Name",
  },
  {
    filetype: "PDF",
    filename: "File Name",
    filesize: "124KB",
    uploadeddate: "04/12/2024",
    relatedto: "Related Name",
  },
  {
    filetype: "Word",
    filename: "File Name",
    filesize: "1.2MB",
    uploadeddate: "03/12/2024",
    relatedto: "Related Name",
  },
];
export const staticData = [
  {
    timesheetname:
      "William Schaffer (Due 2024-10-07)-NO CONS OVERRIDE-PUSHED TO OFFCYCLE",
    approvalfile: "A-03289-10/11/2024",
    approvalduedate: "9-Oct-24",
    approvalstatus: "",
    rejectionnotes: "",
    timesheetUrl: "Link",
    providername: "",
    facilityCity: "William Allen Schaffer",
    facilityState: "Maine Veterans Home Augusta",
    specialty: "Adult Psychiatry  ",
    clientInvoice: "2062.50 ",
    clientinvoice: "2024-09-23 to 2024-10-06  ",
    payrollContact: "Jacob C. Anderson",
  },
  {
    timesheetname: "Ava Swayze (Due 2024-10-07)",
    approvalfile: "A-03289-10/11/2024",
    approvalduedate: "9-Oct-24",
    approvalstatus: "",
    rejectionnotes: "",
    timesheetUrl: "Link",
    facilityCity: "Ava Marlene Swayze",
    facilityState: "RiverStone",
    specialty: "Hospitalist ",
    clientInvoice: "24640.00  ",
    clientinvoice: "2024-09-23 to 2024-10-06  ",
    payrollContact: "Jacob C. Anderson",
  },
];

export const reportsData = [
  {
    reportName: "Annual Financial Report 2024",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "Employee Engagement Survey Results",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "Customer Satisfaction Report Q1",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "Market Trends Analysis 2024",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "IT Infrastructure Audit",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "Environmental Impact Report",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "Sales Performance Q2",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "Product Development Plan 2025",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "Corporate Social Responsibility Report",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "Risk Assessment Summary",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "Annual Financial Report 2024",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "Annual Financial Report 2024",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
  {
    reportName: "Annual Financial Report 2024",
    reportUrl: `https://us-east-1.online.tableau.com/t/hayeslocumstableau/views/DailyKPIs_v0-4UpdatedDateFilters/Apps`,
  },
];

export const Personadata = [
  "Recruiter",
  "Department",
  "Accounting",
  "Leadership",
  "Guest",
];

export const Personadata1 = [
  {
    user_id: 1,
    personaData: {
      recruiter: true,
      department: false,
      accounting: true,
      leadership: false,
      guest: false,
      admin:false,
    },
  },
];

export const userDataInfo = [
  {
    userType: "Recruiter",
    contactPerson: "Alice Johnson",
    location: "New York",
    speciality: "Cardiology",
    status: "Active",
  },
  {
    userType: "Department",
    contactPerson: "Dr. Brian Carter",
    location: "Los Angeles",
    speciality: "Neurology",
    status: "On Hold",
  },
  {
    userType: "Accounting",
    contactPerson: "Emma Williams",
    location: "Chicago",
    speciality: "Pediatrics",
    status: "Active",
  },
  {
    userType: "Leadership",
    contactPerson: "Michael Smith",
    location: "Houston",
    speciality: "Orthopedics",
    status: "Active",
  },
  {
    userType: "Guest",
    contactPerson: "Sarah Thompson",
    location: "Phoenix",
    speciality: "Dermatology",
    status: "On Hold",
  },
  {
    userType: "Recruiter",
    contactPerson: "Christopher Davis",
    location: "Philadelphia",
    speciality: "Oncology",
    status: "Active",
  },
  {
    userType: "Department",
    contactPerson: "Sophia Martinez",
    location: "San Antonio",
    speciality: "Radiology",
    status: "Active",
  },
  {
    userType: "Accounting",
    contactPerson: "David Wilson",
    location: "San Diego",
    speciality: "Cardiology",
    status: "On Hold",
  },
  {
    userType: "Leadership",
    contactPerson: "Olivia Anderson",
    location: "Dallas",
    speciality: "Endocrinology",
    status: "Active",
  },
  {
    userType: "Guest",
    contactPerson: "James Taylor",
    location: "Austin",
    speciality: "Gastroenterology",
    status: "On Hold",
  },
];

export const facilityDetails = [
  {
    facililty_id_fd: 633,
    facility_account_no_fd: 105931,
    account_name_fd: "Kootenai Health (AKA Kootenai Hospital)",
    account_status_fd: "Prospect",
    create_date_fd: "02/27/2025",
    specialities_fd: "",
    salesforce_id_fd: "105931",
    definitive_id_fd: 1101,
    website_fd: "https://www.fisher.net/",
    type_fd: null,
    street_fd: "2003 Kootenai Health Way",
    city_fd: "Coeur D Alene",
    state_fd: "ID",
    zip_code_fd: 83814,
    country_fd: "United States",
    is_active_fd: false,
    facilitytype_fd: "client",
    parentaccount_fd: "105931",
    facility_account_no_ud: 105931,
    user_id_ud: 678,
    first_name_ud: "Christi",
    last_name_ud: "Gettings",
    full_name_ud: "Christi Gettings",
    title_ud: "",
    is_active_ud: false,
    email_verified_ud: false,
    email_ud: "kmorris3823@example.org",
    account_name_ud: "Kootenai Health (AKA Kootenai Hospital)",
    role_ud: "Facility Admin",
    phone_ud: "",
    tableau_subscription_ud: true,
    salesforce_id_ud: "003US000006iXAxYAM",
  },
];

export const WorkisiteList = {
  count: 1,
  result: [
    {
      id: 601,
      accountNumber: 68303,
      name: "Billings Clinic Bozeman",
      accountStatus: "Executed",
      create_date: "2025-02-20T00:00:00",
      salesforce_id: "SF12345678",
      definitiveId: 0,
      website: "",
      type: "",
      address: {
        street: "3901 Wellness Way",
        city: "Bozeman",
        state: "MT",
        stateCode: "MT",
        postalCode: 59718,
        country: "United States",
      },
      is_active: false,
      facilitytype: "Worksite",
      parentaccount: "9091",
    },
  ],
};

export const worksiteData = [
  {
    id: 9000,
    accountNumber: 9000,
    name: "Billings Clinic Parent",
    accountStatus: "Active",
    create_date: "2025-02-19T00:00:00",
    salesforce_id: "SF12345600",
    definitiveId: 10,
    website: "https://billingsclinic.com",
    type: "Healthcare System",
    address: {
      street: "Main HQ Street",
      city: "Billings",
      state: "MT",
      stateCode: "MT",
      postalCode: 59101,
      country: "United States",
    },
    is_active: true,
    facilitytype: "Headquarters",
    parentaccount: 9000,
  },
  {
    id: 9001,
    accountNumber: 9001,
    name: "St. Vincent Healthcare Parent",
    accountStatus: "Active",
    create_date: "2025-02-19T00:00:00",
    salesforce_id: "SF12345601",
    definitiveId: 11,
    website: "https://stvincentshealthcare.com",
    type: "Healthcare System",
    address: {
      street: "Main HQ Street",
      city: "Billings",
      state: "MT",
      stateCode: "MT",
      postalCode: 59102,
      country: "United States",
    },
    is_active: true,
    facilitytype: "Headquarters",
    parentaccount: 9001,
  },
  {
    id: 601,
    accountNumber: 68303,
    name: "Billings Clinic Bozeman",
    accountStatus: "Executed",
    create_date: "2025-02-20T00:00:00",
    salesforce_id: "SF12345678",
    definitiveId: 0,
    website: "",
    type: "",
    address: {
      street: "3901 Wellness Way",
      city: "Bozeman",
      state: "MT",
      stateCode: "MT",
      postalCode: 59718,
      country: "United States",
    },
    is_active: false,
    facilitytype: "Worksite",
    parentaccount: 9000,
  },
  {
    id: 602,
    accountNumber: 9092,
    name: "Billings Clinic Cody",
    accountStatus: "Executed",
    create_date: "2025-02-20T00:00:00",
    salesforce_id: "SF12345678",
    definitiveId: 0,
    website: "",
    type: "",
    address: {
      street: "201 Yellowstone Ave",
      city: "Cody",
      state: "WY",
      stateCode: "WY",
      postalCode: 82414,
      country: "United States",
    },
    is_active: false,
    facilitytype: "Worksite",
    parentaccount: 9000,
  },
  {
    id: 603,
    accountNumber: 9100,
    name: "St. Vincent Hospital Billings",
    accountStatus: "Executed",
    create_date: "2025-02-21T00:00:00",
    salesforce_id: "SF12345679",
    definitiveId: 1,
    website: "https://stvincentshealthcare.com/billings",
    type: "Hospital",
    address: {
      street: "1234 Hospital Dr",
      city: "Billings",
      state: "MT",
      stateCode: "MT",
      postalCode: 59102,
      country: "United States",
    },
    is_active: true,
    facilitytype: "Main Hospital",
    parentaccount: 9001,
  },
  {
    id: 604,
    accountNumber: 9101,
    name: "St. Vincent Clinic Miles City",
    accountStatus: "Pending",
    create_date: "2025-02-22T00:00:00",
    salesforce_id: "SF12345680",
    definitiveId: 2,
    website: "",
    type: "Clinic",
    address: {
      street: "620 S Haynes Ave",
      city: "Miles City",
      state: "MT",
      stateCode: "MT",
      postalCode: 59301,
      country: "United States",
    },
    is_active: false,
    facilitytype: "Satellite Clinic",
    parentaccount: 9001,
  },
];

export const allSpeciality = [
  "Acute Care",
  "Allergy and Immunology",
  "Anesthesiology",
  "Cardiology",
  "Cardiothoracic Surgery",
  "Certified Anesthesia Assistant",
  "Certified Nurse Midwife",
  "Clinical Cardiac Electrophysiology",
  "Cognitive / Behavioral Neurology",
  "Critical Care Medicine",
  "CRNA",
  "Dermatology",
  "Dermatopathology",
  "Emergency Medicine",
  "Endocrinology, Diabetes and Metabolism",
  "Family Medicine",
  "Gastroenterology",
  "General Surgery",
  "Genetics",
  "Geriatric Medicine",
  "Gynecologic Oncology",
  "Gynecology",
  "Hospice and Palliative Medicine",
  "Hospitalist",
  "Infectious Disease",
  "Internal Medicine",
  "Interventional Cardiology",
  "Maternal-Fetal Medicine",
  "Neonatal-Perinatal Medicine",
  "Nephrology",
  "Neuroimmunology",
  "Neurointerventional Surgery",
  "Neurology",
  "Neurosurgery",
  "Nurse Practitioner",
  "OB-GYN",
  "OB-GYN Subspecialties",
  "Occupational Medicine",
  "Oncology",
  "Ophthalmology",
  "Oral & Maxillofacial Surgery",
  "Orthopedic Surgery",
  "Ortho Subs",
  "Otolaryngology",
  "Pathology",
  "Pediatric Anesthesiology",
  "Pediatric Cardiology",
  "Pediatric Critical Care Medicine",
  "Pediatric Emergency Medicine",
  "Pediatric Neurology",
  "Pediatric Otolaryngology",
  "Pediatric Pathology",
  "Pediatric Pulmonary Disease",
  "Pediatrics",
  "Pediatric Sleep Medicine",
  "Pediatric Surgery",
  "Pediatric Urology",
  "Physical Medicine and Rehabilitation",
  "Physician Assistant",
  "Plastic Surgery",
  "Podiatry",
  "Primary Care",
  "Psychiatry",
  "Pulmonary & Critical Care Medicine",
  "Pulmonary Disease",
  "Radiology",
  "Reproductive Endocrinology and Infertility",
  "Rheumatology",
  "Sports Medicine",
  "Trauma Surgery",
  "Urgent Care",
  "Urogynecology",
  "Urology",
  "Vascular Surgery"
];


  export  const columnsInvoice = [
   "invoiceNumber",
    "confirmationNumber",
    "status",
    "provider",
    "specialty",
    "practitionerType",
    "facilityName",
    "invoiceDate",
    "amount",
    "timesheetClientInvoiceTotal",
    "expensesTotal",
    "ammountRecivableSpecialist",
    "clientConsultant",
  
  ].map((key) => ({ field: key, label: "" }))
  export  const columnsShift = [
   "confirmationNumber",
    "bookingStatus",
    "shiftType",
    "clientRate",
    "shiftStartDate",
    "shiftEndDate",
    "shiftTimes",
    "provider",
    "specialty",
    "practitionerType",
    "facilityName",
    "consultantName",
    "bookingName",
  
  ].map((key) => ({ field: key, label: "" }))

    export const columnsSMT = [
      "confirmationNumber",
      "approvalStatus",
      "timesheetNumber",
      "providerName",
      "specialty",
      "practitionerType",
      "facilityName",
      "timesheetURL",
      "nsInvoiceNumber",
      "beeperCount",
      "otCount",
      "payPeriod",
      "payrollContact",
      "Consultant",
      "timesheetNumber",
    ].map((key) => ({ field: key, label: "" }))

    export const columnsTimeEntries = [
      "confirmationNumber",
      "timesheetNumber",
      "timesheetApproved",
      "provider",
      "specialty",
      "dateWorked",
      "dateOfWeek",
      "ShiftStartEndTime",
      "ShiftType",
      "otCount",
      "beeperCount",
      "invoiceNumber",
      "consultantName",
      "timeEntryName",
    ].map((key) => ({ field: key, label: "" }))

    export const columnsInvEntries = [
      "invoiceNumber",
      "invoiceDate",
      "expenseType",
      "description",
      "amount",
      "providerName",
      "specialty",
      "facilityName",
      "accountsReceivableSpecialist",
      "otCount",
      "confirmationNumber",
      
    ].map((key) => ({ field: key, label: "" }))
    
    export const columnsInvTimeEntries = [
      "invoiceNumber",
      "invoiceDate",
      "shiftType",
      "typeCode",
      "dayCount",
      "rate",
      "amount",
      "description",
      "providerName",
      "specialty",
      "facilityName",
      "accountsReceivableSpecialist",
      "consultant",
      "confirmationNumber",

    ].map((key) => ({ field: key, label: "" }))

    export const columnsInvDocuments = [
      "fileName",
      "fileSize",
      "uploadedDate",
    ].map((key) => ({ field: key, label: "" }))

      export const columnsMtgInvoices = [
      "confirmationNumber",
      "invoiceNumber",
      "status",
      "provider",
      "specialty",
      "practitionerType",
      "facilityName",
      "invoiceDate",
      "amount",
      "timesheetClientInvoiceTotal",
      "expensesTotal",
      "ammountRecivableSpecialist",
      "clientConsultant",
       
    ].map((key) => ({ field: key, label: "" }))
     